module.exports = __webpack_public_path__ + "static/icons/icon-legend-buoys-8a2c29f5d483643b876536f3c9083139.svg";